import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MAIN_CONTAINER_CLASS, PAGE_CONTAINER_CLASS } from '@ftr/foundation'
import { FooterDisclaimerComponent } from '../footer-disclaimer'
import { FooterLoggedOutComponent } from '../footer-logged-out'

@Component({
  selector: 'ftr-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  imports: [RouterModule, FooterDisclaimerComponent, FooterLoggedOutComponent],
})
export class FooterComponent {
  readonly mainContainerClass = MAIN_CONTAINER_CLASS
  readonly pageContainerClass = PAGE_CONTAINER_CLASS
}
